import { render } from "./PayrunType.vue?vue&type=template&id=1ef6dffd"
import script from "./PayrunType.vue?vue&type=script&lang=js"
export * from "./PayrunType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__